export enum amenitiesEnum {
    washroom = 'family_restroom',
    service = 'build',
    carWash = 'local_car_wash',
    air = 'air',
    parking = 'local_parking',
    atm = 'atm',
    wifi = 'router',
    pet = 'pets',
    cafe = 'local_cafe',
    bar = 'local_bar',
    restaurent = 'restaurant',
    pharmacy = 'medical_services',
    hotel = 'bed',
    hospital = 'home_health',
    cinema = 'movie',
    gym = 'fitness_center',
    art = 'brush',
    library = 'local_library',
    liveMusic = 'album',
    park = 'nature_people',
    kidsPlayZone = 'child_care',
    salon = 'dry_cleaning',
    school = 'school',
    groceries = 'local_convenience_store',
    ShoppingMall = 'sell',
    beauty = 'style',
    electronics = 'cable',
    carDealer = 'electric_car',
    sports = 'sports_cricket',
    default = 'mail_outline'
}